/*
 * Copyright (c) 2021 Adres.
 * All rights reserved.
 */

const styles = theme => ({
  titleHeadActions: {
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center',

    '& button': {
      '& .MuiButton-label': {
        display: 'flex',
        alignItems: 'center',
        '& > p': {
          color: theme.palette.primary.main,
          fontSize: '16px',
          fontWeight: 600,
          textTransform: 'capitalize',
          [theme.breakpoints.down('sm')]: {
            fontSize: '14px',
            fontWeight: 500,
          },
        },
        '& > span': {
          marginRight: '6px',
        },
      },
    },
    '& > span': {
      margin: '0px 4px',
    },
  },
});

export default styles;
